import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { Companion_getInstanceu2wrlss616lb as Companion_getInstance } from '../../../../../ktor-ktor-http/io/ktor/http/HttpStatusCode.mjs';
import { Collection1k04j3hzsbod0 as Collection } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/Collections.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import {
  listOfvhqybd2zx248 as listOf,
  checkIndexOverflow3frtmheghr0th as checkIndexOverflow,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/collectionJs.mjs';
import {
  plus310ted5e4i90h as plus,
  firstOrNull1982767dljvdy as firstOrNull,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import { get_lastIndex1yw0x4k50k51w as get_lastIndex } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/CollectionsKt.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { constructCallableReference23y65rf941mch as constructCallableReference } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { Send_instance1oebf6ttzyqzk as Send_instance } from './api/CommonHooks.mjs';
import { get_authority2s3hk87lssumy as get_authority } from '../../../../../ktor-ktor-http/io/ktor/http/Url.mjs';
import { get_isTraceEnabled82xibuu04nxp as get_isTraceEnabled } from '../../../../../ktor-ktor-utils/io/ktor/util/logging/Logger.web.mjs';
import { HttpRequestBuilder15f2nnx9sjuv1 as HttpRequestBuilder } from '../request/HttpRequest.mjs';
import { takeFrom3rd40szpqy350 as takeFrom } from '../../../../../ktor-ktor-http/io/ktor/http/URLParser.mjs';
import { _Char___init__impl__6a9atxrzocepzq3zgi as _Char___init__impl__6a9atx } from '../../../../../kotlin-kotlin-stdlib/kotlin/Char.mjs';
import { substringBefore3n7kj60w69hju as substringBefore } from '../../../../../kotlin-kotlin-stdlib/kotlin/text/Strings.mjs';
import { charSequenceLength3278n89t01tmv as charSequenceLength } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/charSequenceJs.mjs';
import { isSecurex1qiiavqi0xu as isSecure } from '../../../../../ktor-ktor-http/io/ktor/http/URLProtocol.mjs';
import { get_authorityakhc3pgcrb9j as get_authority_0 } from '../../../../../ktor-ktor-http/io/ktor/http/URLBuilder.mjs';
import { orPromise1iucc2to2udt2 as orPromise } from '../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/coroutinesInteropJs.mjs';
import { Companion_getInstance29j9s2wnmk34z as Companion_getInstance_0 } from '../../../../../ktor-ktor-http/io/ktor/http/HttpMethod.mjs';
import { setOf45ia9pnfhe90 as setOf } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/Sets.mjs';
import { KtorSimpleLogger1xdphsp5l4e48 as KtorSimpleLogger } from '../../../../../ktor-ktor-utils/io/ktor/util/logging/KtorSimpleLogger.web.mjs';
import { EventDefinition1fymk8xrdelhn as EventDefinition } from '../../../../../ktor-ktor-events/io/ktor/events/Events.mjs';
import { createClientPluginjwpvufjows5r as createClientPlugin } from './api/CreatePluginUtils.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function get_ALLOWED_FOR_REDIRECT() {
  _init_properties_HttpRedirect_kt__ure7fo();
  return ALLOWED_FOR_REDIRECT;
}
var ALLOWED_FOR_REDIRECT;
function get_LOGGER() {
  _init_properties_HttpRedirect_kt__ure7fo();
  return LOGGER;
}
var LOGGER;
function get_HttpResponseRedirectEvent() {
  _init_properties_HttpRedirect_kt__ure7fo();
  return HttpResponseRedirectEvent;
}
var HttpResponseRedirectEvent;
function get_HttpRedirect() {
  _init_properties_HttpRedirect_kt__ure7fo();
  return HttpRedirect;
}
var HttpRedirect;
var HttpRedirectConfigClass;
function HttpRedirectConfig() {
  if (HttpRedirectConfigClass === VOID) {
    class $ {
      constructor() {
        this.v5s_1 = true;
        this.w5s_1 = false;
      }
    }
    initMetadataForClass($, 'HttpRedirectConfig', HttpRedirectConfig);
    HttpRedirectConfigClass = $;
  }
  return HttpRedirectConfigClass;
}
function isRedirect(_this__u8e3s4) {
  _init_properties_HttpRedirect_kt__ure7fo();
  var tmp0_subject = _this__u8e3s4.d58_1;
  return tmp0_subject === Companion_getInstance().l56_1.d58_1 || tmp0_subject === Companion_getInstance().m56_1.d58_1 || (tmp0_subject === Companion_getInstance().r56_1.d58_1 || (tmp0_subject === Companion_getInstance().s56_1.d58_1 || tmp0_subject === Companion_getInstance().n56_1.d58_1)) ? true : false;
}
function removeDotSegments(_this__u8e3s4) {
  _init_properties_HttpRedirect_kt__ure7fo();
  var tmp$ret$0;
  $l$block_0: {
    // Inline function 'kotlin.collections.none' call
    var tmp;
    if (isInterface(_this__u8e3s4, Collection())) {
      tmp = _this__u8e3s4.n1();
    } else {
      tmp = false;
    }
    if (tmp) {
      tmp$ret$0 = true;
      break $l$block_0;
    }
    var _iterator__ex2g4s = _this__u8e3s4.p1();
    while (_iterator__ex2g4s.q1()) {
      var element = _iterator__ex2g4s.r1();
      if (element === '.' || element === '..') {
        tmp$ret$0 = false;
        break $l$block_0;
      }
    }
    tmp$ret$0 = true;
  }
  if (tmp$ret$0)
    return _this__u8e3s4;
  var segments = firstOrNull(_this__u8e3s4) === '' ? _this__u8e3s4 : plus(listOf(''), _this__u8e3s4);
  var output = ArrayList().i2(segments.q2());
  // Inline function 'kotlin.collections.forEachIndexed' call
  var index = 0;
  var _iterator__ex2g4s_0 = segments.p1();
  while (_iterator__ex2g4s_0.q1()) {
    var item = _iterator__ex2g4s_0.r1();
    var _unary__edvuaz = index;
    index = _unary__edvuaz + 1 | 0;
    var isLast = checkIndexOverflow(_unary__edvuaz) === get_lastIndex(segments);
    switch (item) {
      case '.':
        if (isLast) {
          output.j2('');
        }

        break;
      case '..':
        if (output.q2() > 1) {
          output.a5(get_lastIndex(output));
        }

        if (isLast) {
          output.j2('');
        }

        break;
      default:
        output.j2(item);
        break;
    }
  }
  return output;
}
function HttpRedirectConfig$_init_$ref_rhym9t() {
  return constructCallableReference(() => new (HttpRedirectConfig())(), 0, 0, 220, '<init>');
}
function HttpRedirect$lambda($this$createClientPlugin) {
  _init_properties_HttpRedirect_kt__ure7fo();
  var checkHttpMethod = $this$createClientPlugin.b5q_1.v5s_1;
  var allowHttpsDowngrade = $this$createClientPlugin.b5q_1.w5s_1;
  var tmp = Send_instance;
  $this$createClientPlugin.e5q(tmp, HttpRedirect$lambda$slambda(checkHttpMethod, allowHttpsDowngrade, $this$createClientPlugin));
  return Unit_instance;
}
function *invoke$handleCall(_this__u8e3s4, context, origin, allowHttpsDowngrade, client, $completion) {
  var call = origin;
  var requestBuilder = context;
  while (true) {
    var previousProtocol = call.y5l().h5m().i59_1;
    var previousAuthority = get_authority(call.y5l().h5m());
    if (!isRedirect(call.a5k().o5m()))
      return call;
    var location = call.a5k().e55().t2q('Location');
    if (location == null) {
      get_LOGGER().z4w('Location header missing from redirect response ' + call.y5l().h5m().toString() + '; returning response as is');
      return call;
    }
    client.t5j_1.e4x(get_HttpResponseRedirectEvent(), call.a5k());
    // Inline function 'io.ktor.util.logging.trace' call
    var this_0 = get_LOGGER();
    if (get_isTraceEnabled(this_0)) {
      var tmp$ret$1 = 'Received redirect response to ' + location + ' for request ' + call.y5l().h5m().toString();
      this_0.b4x(tmp$ret$1);
    }
    // Inline function 'kotlin.apply' call
    var this_1 = new (HttpRequestBuilder())();
    this_1.z5o(requestBuilder);
    this_1.h5l_1.s58_1.y4();
    takeFrom(this_1.h5l_1, location);
    // Inline function 'kotlin.text.isNotEmpty' call
    var this_2 = substringBefore(substringBefore(location, _Char___init__impl__6a9atx(35)), _Char___init__impl__6a9atx(63));
    if (charSequenceLength(this_2) > 0) {
      this_1.h5l_1.q58_1 = removeDotSegments(this_1.h5l_1.q58_1);
    }
    if (!allowHttpsDowngrade && isSecure(previousProtocol) && !isSecure(this_1.h5l_1.v58())) {
      // Inline function 'io.ktor.util.logging.trace' call
      var this_3 = get_LOGGER();
      if (get_isTraceEnabled(this_3)) {
        var tmp$ret$6 = 'Blocked redirect from ' + call.y5l().h5m().toString() + ' to ' + location + ' due to HTTPS downgrade';
        this_3.b4x(tmp$ret$6);
      }
      return call;
    }
    if (!(previousAuthority === get_authority_0(this_1.h5l_1))) {
      this_1.j5l_1.a4t('Authorization');
      // Inline function 'io.ktor.util.logging.trace' call
      var this_4 = get_LOGGER();
      if (get_isTraceEnabled(this_4)) {
        var tmp$ret$8 = 'Removing Authorization header for cross-authority redirect: ' + (previousAuthority + ' -> ' + this_1.h5l_1.f5a());
        this_4.b4x(tmp$ret$8);
      }
    }
    requestBuilder = this_1;
    call = yield* _this__u8e3s4.i5s(requestBuilder, $completion);
  }
}
function HttpRedirect$lambda$slambda($checkHttpMethod, $allowHttpsDowngrade, $this_createClientPlugin) {
  return constructCallableReference(($this$on, request, $completion) => orPromise($completion, function *($completion) {
    var origin = yield* $this$on.i5s(request, $completion);
    var tmp;
    if ($checkHttpMethod && !get_ALLOWED_FOR_REDIRECT().t2(origin.y5l().g5m())) {
      return origin;
    }
    return yield* /*#__NOINLINE__*/invoke$handleCall($this$on, request, origin, $allowHttpsDowngrade, $this_createClientPlugin.a5q_1, $completion);
  }), 2);
}
var properties_initialized_HttpRedirect_kt_klj746;
function _init_properties_HttpRedirect_kt__ure7fo() {
  if (!properties_initialized_HttpRedirect_kt_klj746) {
    properties_initialized_HttpRedirect_kt_klj746 = true;
    ALLOWED_FOR_REDIRECT = setOf([Companion_getInstance_0().f55_1, Companion_getInstance_0().k55_1]);
    LOGGER = KtorSimpleLogger('io.ktor.client.plugins.HttpRedirect');
    HttpResponseRedirectEvent = new (EventDefinition())();
    var tmp = HttpRedirectConfig$_init_$ref_rhym9t();
    HttpRedirect = createClientPlugin('HttpRedirect', tmp, HttpRedirect$lambda);
  }
}
//region block: exports
export {
  get_HttpRedirect as get_HttpRedirect1lgx3wewnhrb0,
};
//endregion

//# sourceMappingURL=HttpRedirect.mjs.map
